import PropTypes from 'prop-types';

const KnittedIcon = ({ className = '' }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M71.9998 0H8.00049C3.58221 0 0.000488281 3.58172 0.000488281 7.99999V71.9997C0.000488281 76.418 3.58222 79.9997 8.0005 79.9997H71.9999C76.4181 79.9997 79.9999 76.418 79.9999 71.9997V8C79.9999 3.58172 76.4181 0 71.9998 0Z"
      fill="white"
    />
    <path d="M22.8333 0H11.5V79.9997H22.8333V45.7141V0Z" fill="#0A0777" />
    <path d="M45.6672 0H34.334V79.9997H45.6672V45.7141V0Z" fill="#0A0777" />
    <path d="M68.4993 0H57.166V79.9997H68.4993V45.7141V0Z" fill="#0A0777" />
    <path
      d="M34.334 22.8343L34.334 11.501L0.000854492 11.501L0.000853997 22.8343L14.7151 22.8343L34.334 22.8343Z"
      fill="#FB6E44"
    />
    <path
      d="M79.9995 22.8343L79.9995 11.501L45.6664 11.501L45.6664 22.8343L60.3806 22.8343L79.9995 22.8343Z"
      fill="#FB6E44"
    />
    <path
      d="M11.5 45.6634L11.5 34.3301L7.05719e-05 34.3301L7.00765e-05 45.6634L4.92861 45.6634L11.5 45.6634Z"
      fill="#FB6E44"
    />
    <path
      d="M79.9995 45.6634L79.9995 34.3301L68.4996 34.3301L68.4996 45.6634L73.4281 45.6634L79.9995 45.6634Z"
      fill="#FB6E44"
    />
    <path
      d="M57.166 45.6634L57.166 34.3301L22.8329 34.3301L22.8329 45.6634L37.5471 45.6634L57.166 45.6634Z"
      fill="#FB6E44"
    />
    <path
      d="M34.334 68.5013L34.334 57.168L0.000854492 57.168L0.000853997 68.5013L14.7151 68.5013L34.334 68.5013Z"
      fill="#FB6E44"
    />
    <path
      d="M79.9995 68.5013L79.9995 57.168L45.6664 57.168L45.6664 68.5013L60.3806 68.5013L79.9995 68.5013Z"
      fill="#FB6E44"
    />
  </svg>
);

KnittedIcon.propTypes = {
  className: PropTypes.string
};

export default KnittedIcon;
